"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectUrlProvider = exports.useProjectUrlContext = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const AppRouter_1 = require("src/configeek_assets/src/components/common/AppRouter");
const lodash_1 = __importDefault(require("lodash"));
const ProjectUrlContext = React.createContext(undefined);
const useProjectUrlContext = () => {
    const context = React.useContext(ProjectUrlContext);
    if (!context) {
        throw new Error("useProjectUrlContext must be used within a ProjectUrlContext.Provider");
    }
    return context;
};
exports.useProjectUrlContext = useProjectUrlContext;
const ProjectUrlProvider = (props) => {
    const routeMatch = (0, react_router_dom_1.useRouteMatch)(AppRouter_1.PATH__PROJECT_ROOT);
    // console.log("ProjectUrlProvider: routeMatch", routeMatch);
    if ((routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.params.projectApiKey) == undefined || lodash_1.default.isEmpty(routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.params.projectApiKey)) {
        // console.log("ProjectUrlProvider: no projectApiKey => redirect");
        return React.createElement(react_router_dom_1.Redirect, { to: AppRouter_1.PATH__HOME });
    }
    const projectApiKey = routeMatch.params.projectApiKey;
    const value = (0, react_1.useMemo)(() => ({
        projectApiKey
    }), [projectApiKey]);
    // console.log("ProjectUrlProvider: value", value);
    return React.createElement(ProjectUrlContext.Provider, { value: value }, props.children);
};
exports.ProjectUrlProvider = ProjectUrlProvider;
